import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  IconButton,
  Typography,
  LinearProgress,
  Button,
} from "@mui/material";
import PropTypes from "prop-types";
import { API_get_calendar_messages_tomorrow } from "./utils/http";
import dayjs from "dayjs";
import ContentCopyTwoToneIcon from "@mui/icons-material/ContentCopyTwoTone";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function CalendarMess() {
  const [value, setValue] = useState(1);

  //   call api
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetch_data(query_string) {
    await API_get_calendar_messages_tomorrow(query_string, (data) => {
      setData(data.data);
      setLoading(false);
    });
  }

  const copyToClipboard = (text) => {
    try {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
      } else {
        navigator.clipboard
          .writeText(text)
          .then(() => {})
          .catch((err) => {
            console.error("Could not copy text: ", err);
            fallbackCopyTextToClipboard(text);
          });
      }
    } catch (err) {
      console.error("Clipboard error: ", err);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      const msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text was " + msg);
      if (!successful) {
      }
    } catch (err) {
      console.error("Fallback: Could not copy text: ", err);
    }

    document.body.removeChild(textArea);
  };

  useEffect(() => {
    fetch_data("tomorrow");
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  if (loading) {
    return <LinearProgress />;
  }
  if (error) {
    return <AlertCus condition={error} message="Error" />;
  }
  if (data.length === 0) {
    return <Typography>No data</Typography>;
  }
  if (data.length > 0) {
    return (
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          {/* refresh button */}
          <Button
            style={{ margin: 10 }}
            onClick={() => fetch_data("tomorrow")}
            variant="contained"
            color="primary"
          >
            Refresh
          </Button>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label={`Today: (${dayjs().format("dddd DD MMMM")})`}
              {...a11yProps(0)}
              onClick={() => fetch_data("today")}
            />
            <Tab
              label={`Tomorrow: (${dayjs()
                .add(1, "day")
                .format("dddd DD MMMM")})`}
              {...a11yProps(1)}
              onClick={() => fetch_data("tomorrow")}
            />
            <Tab
              label={`${dayjs().add(2, "day").format("dddd DD MMMM")}`}
              {...a11yProps(2)}
              onClick={() => fetch_data("next_2_days")}
            />
          </Tabs>
        </Box>

        <Box>
          {data.map((item) => (
            <Card
              key={item._id}
              sx={{
                marginBottom: 2,
                borderRadius: 2,
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.2s ease-in-out",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
                },
              }}
            >
              <CardContent
                sx={{
                  p: 3,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        color: "primary.main",
                        fontWeight: "bold",
                      }}
                    >
                      {item.booking_number}
                    </Typography>
                  </Box>
                  {/* customer name and phone */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "text.secondary", minWidth: "120px" }}
                    >
                      Customer:
                    </Typography>
                    <Typography variant="body2">
                      {item.customer_name}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "text.secondary", minWidth: "120px" }}
                    >
                      Phone:
                    </Typography>
                    <Typography variant="body2">
                      {item.customer_phone == "TBA"
                        ? ""
                        : ` ${item.customer_phone}`}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "text.secondary", minWidth: "120px" }}
                    >
                      Itinerary:
                    </Typography>
                    <Typography variant="body2">
                      {item.activity_label}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "text.secondary", minWidth: "120px" }}
                    >
                      Accom:
                    </Typography>
                    <Typography variant="body2">
                      {item.accommodation_label}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "text.secondary", minWidth: "120px" }}
                    >
                      Day trip:
                    </Typography>
                    <Typography variant="body2">{item.day_index}</Typography>
                  </Box>
                </Box>

                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      color: "primary.main",
                      fontWeight: "bold",
                    }}
                  >
                    Message:
                    <IconButton
                      color="primary"
                      onClick={() => copyToClipboard(item.message_tool)}
                    >
                      <ContentCopyTwoToneIcon />
                    </IconButton>
                  </Typography>
                  <Typography variant="body2">{item.message_tool}</Typography>
                  {/* copy button */}
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    );
  }
}
